import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import { FaMoneyBillWave, FaChartLine, FaWallet } from 'react-icons/fa';
import { Link } from 'react-router-dom'
function BalanceSheet() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [dateRange, setDateRange] = useState({
    startDate: moment().startOf('month').format('YYYY-MM-DD'),
    endDate: moment().endOf('month').format('YYYY-MM-DD')
  });

  const fetchBalanceSheet = async (startDate, endDate) => {
    try {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('authToken');

      if (!token) {
        throw new Error('No authentication token found');
      }

      const response = await axios.get(`https://backendapi.safairo.com/api/v1/balance-sheet`, {
        params: {
          startDate,
          endDate
        },
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setData(response.data.data);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch balance sheet');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBalanceSheet(dateRange.startDate, dateRange.endDate);
  }, []);

  const handleDateChange = (e) => {
    const { name, value } = e.target;
    setDateRange(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchBalanceSheet(dateRange.startDate, dateRange.endDate);
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      minimumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div className="right_col" role="main">
      <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

        <div className="my-auto">

          <h5 className="page-title fs-21 mb-1">Balance Sheet</h5>
          <nav>

            <ol className="breadcrumb mb-0">

              <li className="breadcrumb-item">
                <a href="javascript:void(0);">Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Balance Sheet
              </li>
            </ol>
          </nav>
        </div>
        <div className="d-flex my-xl-auto right-content align-items-center">

          <Link className="excel-btn" to={`/dashboard`}>
            Back
          </Link>


        </div>
      </div>


      {/* Date Range Selector */}
      <div className='container-box px-0 user-manager mb-0'>
        <div className="Tablesearch_design  mb-0 py-0">

          <form onSubmit={handleSubmit} className="form-inline">
            <div className="row">
              <div className='col-md-4'> <div className="form-group mr-2 w-100">
                <label htmlFor="startDate" className="mr-2">From:</label>
                <input
                  type="date"
                  className="form-control"
                  id="startDate"
                  name="startDate"
                  value={dateRange.startDate}
                  onChange={handleDateChange}
                  max={moment().format('YYYY-MM-DD')}
                />
              </div></div>
              <div className='col-md-4'><div className="form-group mr-2 w-100">
                <label htmlFor="endDate" className="mr-2">To:</label>
                <input
                  type="date"
                  className="form-control"
                  id="endDate"
                  name="endDate"
                  value={dateRange.endDate}
                  onChange={handleDateChange}
                  max={moment().format('YYYY-MM-DD')}
                />
              </div></div>
              <div className='col-md-4 d-flex align-items-center'>   <div>
                <button type="submit" className="excel-btn" disabled={loading}>
                  {loading ? 'Loading...' : 'Apply'}
                </button>
              </div>
              </div>



            </div>
          </form>

        </div>    
      </div>
      {error && (
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
        )}

        {loading ? (
          <div className="text-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        ) : data ? (
          <>
            {/* Summary Cards */}
            {/* <div className="row mb-4">
            <div className="col-md-4 mb-3">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">Total Income</h5>
                  <h2 className={`card-text ${data.income.total >= 0 ? 'text-success' : 'text-danger'}`}>
                    {formatCurrency(data.income.total)}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">Total Expenses</h5>
                  <h2 className="text-danger">
                    {formatCurrency(data.expenses.total)}
                  </h2>
                </div>
              </div>
            </div>
            <div className="col-md-4 mb-3">
              <div className="card h-100">
                <div className="card-body">
                  <h5 className="card-title">Net Profit</h5>
                  <h2 className={`${data.netProfit >= 0 ? 'text-success' : 'text-danger'}`}>
                    {formatCurrency(data.netProfit)}
                  </h2>
                </div>
              </div>
            </div>
          </div> */}
         <div className='container-box bg-transparent shadow-none px-0 mb-0'>
         <div className='mt-2'>
              <div className="row mb-4">
                <div className="col-md-4 mb-3">
                  <div className="card h-100">
                    <div className="card-body">
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='new_icon'>
                          <FaMoneyBillWave className="" />
                        </div>
                        <div>
                          <h5 className="card-title d-flex align-items-center mb-0">
                            Total Income
                          </h5>
                          <h3 className={`card-text ${data.income.total >= 0 ? 'text-success' : 'text-danger'}`}>
                            {formatCurrency(data.income.total)}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div className="card h-100">
                    <div className="card-body">
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='new_icon'>
                          <FaWallet className="" />
                        </div>
                        <div>
                          <h5 className="card-title d-flex align-items-center mb-0">
                            Total Expenses
                          </h5>
                          <h3 className="text-danger">
                            {formatCurrency(data.expenses.total)}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4 mb-3">
                  <div className="card h-100">
                    <div className="card-body">
                      <div className='d-flex gap-2 align-items-center'>
                        <div className='new_icon'>
                          <FaChartLine className="" />
                        </div>
                        <div>
                          <h5 className="card-title d-flex align-items-center mb-0">
                            Net Profit
                          </h5>
                          <h3 className={`${data.netProfit >= 0 ? 'text-success' : 'text-danger'}`}>
                            {formatCurrency(data.netProfit)}
                          </h3>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Income Breakdown */}
              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <div className="card">
                    <div className="card-header new_bg_design">
                      <h5>Online Income</h5>
                    </div>
                    <div className="card-body">
                      <h3 className="text-success">{formatCurrency(data.income.online)}</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="card">
                    <div className="card-header new_bg_design">
                      <h5>Cash Income</h5>
                    </div>
                    <div className="card-body">
                      <h3 className="text-success">{formatCurrency(data.income.cash)}</h3>
                    </div>
                  </div>
                </div>
              </div>

              {/* Expenses Breakdown */}
              <div className="row mb-4">
                <div className="col-md-6 mb-3">
                  <div className="card">
                    <div className="card-header new_bg_design">
                      <h5>Other Expenses</h5>
                    </div>
                    <div className="card-body">
                      <h3 className="text-danger">{formatCurrency(data.expenses.otherExpenses)}</h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 mb-3">
                  <div className="card">
                    <div className="card-header new_bg_design">
                      <h5>Purchases</h5>
                    </div>
                    <div className="card-body">
                      <h3 className="text-danger">{formatCurrency(data.expenses.purchases)}</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
         </div>

            
          </>
        ) : null}


    </div>

  );
}

export default BalanceSheet;